<script>
  import { domainName, recordCreated } from '../stores.js';
</script>

<div class="record-box record-instructions">
  <div id="headingRaw" class="box-label">
    <h5>Instructions</h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseInstructions" aria-expanded="false" aria-controls="collapseInstructions" aria-label="Close"></button>
  </div>
  <div id="collapseInstructions" class="box-detail collapse" aria-labelledby="headingRaw">
    <p><strong>Updating Your DNS for DMARC</strong></p>
    <p>The exact steps to publish your DMARC record will vary based on how the DNS for your domain is managed. However you submit requests for DNS changes, you will need to request that this DMARC record be published as a TXT resource record. The record must be published at the subdomain created by pre-pending _dmarc. as indicated in the DNS Record Location below. Be sure to include the full DMARC Record below. There should be no line-wraps, new lines, or whitespace other than the spaces explicitly shown within the record below.</p>
    <p>A. If you have direct access to manage DNS for your domain through an online DNS administration tool, look for a section to publish a TXT record or a section specific to DMARC records.</p>
    <p>B. If you have access to manage DNS for your domain through a web hosting online administrative interface, look for DNS Settings and a place to enter a TXT record or a DMARC record.</p>
    <p>C. If your company manages its DNS internally, you may need to submit a request to publish the DNS record through your company's DNS management team.</p>
    <p>D. If a third party hosts DNS for your domain you may need to submit a ticket with them to update the domain's DNS settings.</p>
    <p>Your domain's DNS provider is unknown.</p>

    <p><strong>Domain</strong></p>
    <p>{$domainName}</p>

    <p><strong>DNS Record Location</strong></p>
    <p>_dmarc.{$domainName}</p>

    <p><strong>DMARC Record</strong></p>
    <p>{$recordCreated.raw}</p>

    <p>Please note that it may take up 48 hours for the changes to appear within Agari after the record is published by your DNS provider.</p>
  </div>
</div>

<style>

</style>
